<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md>
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="organization"
          :items="organizations"
          item-value="_id"
          flat
          solo
          :label="$t('invoice.organization')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template v-slot:selection="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>

          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getLocalisedValue(item.name) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md>
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="training"
          :items="trainings"
          item-value="_id"
          flat
          solo
          :label="$t('invoice.course')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template v-slot:selection="{ item }">
            {{ getLocalisedValue(item.title) }}
          </template>

          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getLocalisedValue(item.title) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :disabled="loading"
              hide-details
              v-model="formattedStartDate"
              :label="$t('invoice.chooseFromDate')"
              class="rounded-lg"
              flat
              solo
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            >
              <v-icon slot="append" color="textLight">
                mdi-calendar-blank-outline
              </v-icon></v-text-field
            >
          </template>

          <v-date-picker
            color="primary"
            v-model="startDate"
            no-title
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :disabled="loading"
              hide-details
              class="rounded-lg"
              :label="$t('invoice.chooseToDate')"
              v-model="formattedEndDate"
              flat
              solo
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            >
              <v-icon slot="append" color="textLight">
                mdi-calendar-blank-outline
              </v-icon></v-text-field
            >
          </template>

          <v-date-picker
            color="primary"
            v-model="endDate"
            no-title
            @input="endDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "InvoicesTableFilters",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    organizationProp: null,
    trainingProp: null,
    startDateProp: null,
    endDateProp: null,
  },
  data() {
    return {
      organization: null,
      training: null,
      organizations: [],
      trainings: [],
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
    };
  },
  computed: {
    formattedStartDate: {
      get() {
        return this.startDate
          ? this.$moment(this.startDate).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.startDate = value
      },
    },
    formattedEndDate: {
      get() {
        return this.endDate
          ? this.$moment(this.endDate).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.endDate = value
      },
    },
  },
  watch: {
    organizationProp() {
      this.organization = this.organizationProp;
    },
    trainingProp() {
      this.training = this.trainingProp;
    },
    startDateProp() {
      this.startDate = this.startDateProp;
    },
    endDateProp() {
      this.endDate = this.endDateProp;
    },
    organization() {
      this.$emit("filter", "organization", this.organization);
    },
    training() {
      this.$emit("filter", "training", this.training);
    },
    startDate() {
      if (this.startDate && this.endDate) {
        this.$emit("filter", "dates", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } else if (!this.startDate || !this.endDate) {
        this.$emit("filter", "dates", {
          startDate: null,
          endDate: null,
        });
      }
    },
    endDate() {
      if (this.startDate && this.endDate) {
        this.$emit("filter", "dates", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } else if (!this.startDate || !this.endDate) {
        this.$emit("filter", "dates", {
          startDate: null,
          endDate: null,
        });
      }
    },
  },
  apollo: {
    getOrganizations() {
      return {
        query: require("../../organization-module/api/query/getOrganizations.gql"),
        variables: { limit: 0, skip: 0, filterInput: null },
        result({ data }) {
          if (data?.getOrganizations?.organizations) {
            this.organizations = data.getOrganizations.organizations;
          }
        },
      };
    },
    getTrainings() {
      return {
        query: require("../../course-module/api/query/getTrainings.gql"),
        variables: { limit: 0, skip: 0 },
        result({ data }) {
          if (data?.getTrainings?.trainings) {
            this.trainings = data.getTrainings.trainings;
          }
        },
      };
    },
  },
};
</script>
